export default __webpack_public_path__ + "static/media/pin_disabled.2bbc5007.svg";